import { Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-snapshot-list',
  templateUrl: './snapshot-list.component.html',
  styleUrls: ['./snapshot-list.component.scss']
})
export class SnapshotListComponent implements OnInit {
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() snapshotListData;
  @Output() closeMenuEmit = new EventEmitter();
  @Output() deleteSnapshotEmit = new EventEmitter();

  singleSnapshot: any;
  selectAll = false;
  selectedImages = [];

  constructor() { }

  ngOnInit() {
  }

  closeMenu() {
    this.closeMenuEmit.emit(true);
  }

  deleteSnapshot(snapshot) {
    this.singleSnapshot = snapshot;
  }

  modalCloseEmit(snapshot) {
    this.singleSnapshot = undefined;
    if ($('#deleteSnapshotModal')) {
      $('#deleteSnapshotModal').modal('hide');
    }
    if (snapshot) {
      this.deleteSnapshotEmit.emit(snapshot);
    }
  }

  snapshotCheckChange(selectedMedia) {
    this.snapshotListData = _.map(this.snapshotListData, (snapshot) => {
      if (selectedMedia.uuid === snapshot.uuid) {
        snapshot.checked = !snapshot.checked;
      }
      return snapshot;
    });

    this.selectAll = false;

    this.selectedImages = _.filter(this.snapshotListData, {checked: true});
    if (this.selectedImages.length === this.snapshotListData.length) {
      this.selectAll = true;
    } else {
      this.selectAll = false;
    }

  }


  mediaSelectAll() {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.snapshotListData = _.map(this.snapshotListData, (snapshot) => {
        snapshot.checked = true;
        return snapshot;
      });
      this.selectedImages = this.snapshotListData;
    } else {
      this.snapshotListData = _.map(this.snapshotListData, (snapshot) => {
        snapshot.checked = false;
        return snapshot;
      });
      this.selectedImages = [];
    }
  }

}
